module.exports = __webpack_public_path__ + "static/media/escudo-01.9dca3831.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/escudo-01.svg
// module id = 470
// module chunks = 0